import Vue from 'vue'
//Take the config json and generate layers ready for mapbox
let mapBoxDataFactories = {};

mapBoxDataFactories['source'] = class MBSourceFactory {
	constructor(props) {
		let _vue = new Vue();
		return {
			"name": `${props.tablename}-source`,
			"data": {
				"type": "vector",
				"tiles": [`${_vue.$mainConfig.api.hosts.api}mvt/${props.tablename}/{z}/{x}/{y}?geom_column=geom&columns=geoid`]
			}
		}
	}
}

mapBoxDataFactories['layer'] = class MBLayerFactory {
	constructor(props, side) {
		let _vue = new Vue();
		const paintProps = _vue.$styleConfig.styles.outlines.paint[`Prop-${side}`];

		return {
			"id": `${props.tablename}-${side}`,
			"type": "line",
			"source": `${props.tablename}-source`,
			"source-layer": props.tablename,
			"layout": {
				"visibility": "none"
			},
			"paint": paintProps,
			"params": props
		}
	}
}

mapBoxDataFactories['label-source'] = class MBSourceFactory {
	constructor(props) {
		let _vue = new Vue();
		return {
			"name": `${props.tablename}-label-source`,
			"data": {
				"type": "vector",
				"tiles": [`${_vue.$mainConfig.api.hosts.api}mvt/${props.tablename}/{z}/{x}/{y}?geom_column=geom_pt&columns=namelsad`]
			}
		}
	}
}

mapBoxDataFactories['label-layer'] = class MBLabelLayerFactory {
	constructor(props, side) {
		let _vue = new Vue();
		const layoutProps = _vue.$styleConfig.styles.labels.layout;

		const paintProps = _vue.$styleConfig.styles.labels.paint[`Prop-${side}`];

		return {
			"id": `${props.tablename}-label-${side}`,
			"type": "symbol",
			"minzoom": 7,
			"source": `${props.tablename}-label-source`,
			"source-layer": props.tablename,
			"layout": layoutProps,
			"paint": paintProps,
			"params": props
		}
	}
}


mapBoxDataFactories['aerial-source'] = class MBSourceFactory {
	constructor() {
		return {
			"name": 'aerial-source',
			"data": {
				"type": "raster",
				"tiles": ['https://orthos.its.ny.gov/arcgis/rest/services/wms/NAIP_2019/MapServer/tile/{z}/{y}/{x}?blankTile=false'],
				'tileSize': 256,
				'attribution': "USDA National Agricultural Imagery Program (NAIP)"
			}
		}
	}
}

mapBoxDataFactories['aerial-layer'] = class MBLayerFactory {
	constructor() {
		return {
			'id': 'aerial-layer',
			'type': 'raster',
			'source': 'aerial-source',
			'layout': {
				'visibility': 'none'
			},
			'minzoom': 0,
			'maxzoom': 22
		}
	}
}

mapBoxDataFactories['voting-source'] = class MBSourceFactory {
	constructor(props) {
		let _vue = new Vue();
		return {
			"name": `${props.tablename}-source`,
			"data": {
				"type": "vector",
				"tiles": [`${_vue.$mainConfig.api.hosts.api}mvt/${props.tablename}/{z}/{x}/{y}?geom_column=geom&columns=geoid,bidenpct`]
			}
		}
	}
}

mapBoxDataFactories['voting-layer'] = class MBLayerFactory {
	constructor(props) {
		let _vue = new Vue();
		let _choroplethScale = ['step', ['get', 'bidenpct']];
		let scaleNums = _vue.$voteLayerConfig.config.scale.map((s) => { return [s.color, s.step[s.step.length - 2]] }).flat(Infinity);
		_choroplethScale = _choroplethScale.concat(scaleNums)
		_choroplethScale.push('rgba(0,0,0,0)');
		//console.log(JSON.stringify(_choroplethScale))
		return {
			"id": `${props.tablename}`,
			"type": "fill",
			"source": `${props.tablename}-source`,
			"source-layer": props.tablename,
			"layout": {
				"visibility": "none"
			},
			"paint": {
				"fill-opacity": 1,
				"fill-color": _choroplethScale
			},
			"params": props
		}
	}
}

mapBoxDataFactories['voting-source-2024'] = class MBSourceFactory {
	constructor(props) {
		let _vue = new Vue();
		return {
			"name": `${props.tablename}-source`,
			"data": {
				"type": "vector",
				"tiles": [`${_vue.$mainConfig.api.hosts.api}mvt/${props.tablename}/{z}/{x}/{y}?geom_column=geom&columns=geoid,harrispct`]
			}
		}
	}
}

mapBoxDataFactories['voting-layer-2024'] = class MBLayerFactory {
	constructor(props) {
		let _vue = new Vue();
		let _choroplethScale = ['step', ['get', 'harrispct']];
		let scaleNums = _vue.$voteLayerConfig.config.scale.map((s) => { return [s.color, s.step[s.step.length - 2]] }).flat(Infinity);
		_choroplethScale = _choroplethScale.concat(scaleNums)
		_choroplethScale.push('rgba(0,0,0,0)');
		//console.log(JSON.stringify(_choroplethScale))
		return {
			"id": `${props.tablename}`,
			"type": "fill",
			"source": `${props.tablename}-source`,
			"source-layer": props.tablename,
			"layout": {
				"visibility": "none"
			},
			"paint": {
				"fill-opacity": 1,
				"fill-color": _choroplethScale
			},
			"params": props
		}
	}
}

mapBoxDataFactories['vap-source'] = class MBSourceFactory {
	constructor(props) {
		let _vue = new Vue();
		return {
			"name": `${props.tablename}-source`,
			"data": {
				"type": "vector",
				"tiles": [`${_vue.$mainConfig.api.hosts.api}mvt/${props.tablename}/{z}/{x}/{y}?geom_column=geom&columns=geoid,p,v_pct`]
			}
		}
	}
}

mapBoxDataFactories['vap-layer'] = class MBLayerFactory {
	constructor(props) {
		let _vue = new Vue();
		//let _choroplethScale = ['step', ['get', 'v_pct']];
		let _scale = ['step', ['to-number',['get', 'v_pct']]]

		let scaleNums = {
			h: _scale.concat(_vue.$VAPConfig.config.h.scale.map((s) => { return [s.color, s.step[s.step.length - 2]] }).flat(Infinity)),
			w: _scale.concat(_vue.$VAPConfig.config.w.scale.map((s) => { return [s.color.toLowerCase(), +s.step[s.step.length - 2]] }).flat(Infinity)),
			b: _scale.concat(_vue.$VAPConfig.config.b.scale.map((s) => { return [s.color, s.step[s.step.length - 2]] }).flat(Infinity)),
			as: _scale.concat(_vue.$VAPConfig.config.as.scale.map((s) => { return [s.color, s.step[s.step.length - 2]] }).flat(Infinity)),
			ai: _scale.concat(_vue.$VAPConfig.config.ai.scale.map((s) => { return [s.color, s.step[s.step.length - 2]] }).flat(Infinity)),
			n: _scale.concat(_vue.$VAPConfig.config.n.scale.map((s) => { return [s.color, s.step[s.step.length - 2]] }).flat(Infinity)),
			other:_scale.concat(_vue.$VAPConfig.config.other.scale.map((s) => { return [s.color, s.step[s.step.length - 2]] }).flat(Infinity))
		}

		Object.keys(scaleNums).forEach((k)=>{
			scaleNums[k].push('rgba(0,255,0,1)');
		})
		

		let _choroplethScale = [
			"case",
			['==',['get', 'p'],'w'],
			scaleNums['w'],
			['==',['get', 'p'],'h'],
			scaleNums['h'],
			['==',['get', 'p'],'b'],
			scaleNums['b'],
			['==',['get', 'p'],'ai'],
			scaleNums['ai'],
			['==',['get', 'p'],'as'],
			scaleNums['as'],
			['==',['get', 'p'],'n'],
			scaleNums['n'],
			['==',['get', 'p'],'other'],
			scaleNums['other'],
			'rgba(0,0,0,1)'
		]

		return {
			"id": "vap-layer",
			"type": "fill",
			"source": `${props.tablename}-source`,
			"source-layer": props.tablename,
			"layout": {
				"visibility": "none"
			},
			"paint": {
				"fill-opacity": 0.8,
				"fill-color": _choroplethScale
			},
			"params": props
		}
	}
}


mapBoxDataFactories['coi-source'] = class MBSourceFactory {
	constructor(props) {
		let _vue = new Vue();
		return {
			"name": `${props.tablename}-source`,
			"data": {
				"type": "vector",
				"tiles": [`${_vue.$mainConfig.api.hosts.api}mvt/${props.tablename}/{z}/{x}/{y}?geom_column=geom`]
			}
		}
	}
}

mapBoxDataFactories['coi-layer'] = class MBLayerFactory {
	constructor(props) {
		return {
			"id": `${props.tablename}`,
			"type": "fill",
			"source": `${props.tablename}-source`,
			"source-layer": props.tablename,
			"layout": {
				"visibility": "none"
			},
			"paint": props.style,
			"params": props
		}
	}
}


mapBoxDataFactories['coi-label-source'] = class MBSourceFactory {
	constructor(props) {
		let _vue = new Vue();
		return {
			"name": `${props.tablename}-label-source`,
			"data": {
				"type": "vector",
				"tiles": [`${_vue.$mainConfig.api.hosts.api}mvt/${props.tablename}/{z}/{x}/{y}?geom_column=geom_pt&columns=entry_name`]
			}
		}
	}
}

mapBoxDataFactories['coi-label-layer'] = class MBLabelLayerFactory {
	constructor(props) {
		let _vue = new Vue();

		const layoutProps = _vue.$coiConfig.config.labels["layout-props"];

		const paintProps = _vue.$coiConfig.config.labels["paint-props"];

		return {
			"id": `${props.tablename}-label`,
			"type": "symbol",
			"minzoom": 7,
			"source": `${props.tablename}-label-source`,
			"source-layer": props.tablename,
			"layout": layoutProps,
			"paint": paintProps,
			"params": props
		}
	}
}

export default class MapBoxDataFactory {
	constructor(type, props, side) {
		return new mapBoxDataFactories[type](props, side);
	}
}